/**
 * Announces cart item-count changes to assistive tech when the drawer's Section Rendering API
 * response updates the DOM. Observes the existing item-count badge rather than hooking into
 * `cart-drawer-component`'s internals, so it stays resilient to that component's own updates.
 */
const BADGE_ID = 'cart-drawer-item-count-badge';
const LIVE_REGION_ID = 'cart-drawer-update-live-region';

/** @param {string} template @param {number} count */
function formatCount(template, count) {
  return template.replace('{count}', String(count));
}

function announce(count) {
  const liveRegion = document.getElementById(LIVE_REGION_ID);
  if (!liveRegion) return;

  const template = count === 1 ? liveRegion.dataset.templateOne : liveRegion.dataset.templateOther;
  if (!template) return;

  liveRegion.textContent = formatCount(template, count);
}

let lastCount = document.getElementById(BADGE_ID)?.textContent?.trim();

const observer = new MutationObserver(() => {
  const badge = document.getElementById(BADGE_ID);
  const nextCount = badge?.textContent?.trim();

  if (nextCount === undefined || nextCount === lastCount) return;

  lastCount = nextCount;
  const count = Number.parseInt(nextCount, 10);
  if (!Number.isNaN(count)) announce(count);
});

observer.observe(document.body, { childList: true, subtree: true, characterData: true });
